module.exports = __webpack_public_path__ + "img/700_Wireless-connection.b609ddf8.png";